import { useEffect, useRef } from "react";
import gsap from "gsap";

const SplitText = ({
  text = "Enter your headline here",
  className = "",
  delay = 0.1,
  duration = 0.6,
  ease = "back.out(1.7)",
  from = { opacity: 0, y: 20 },
  to = { opacity: 1, y: 0 },
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const chars = containerRef.current.querySelectorAll(".char");
    if (!chars.length) return;

    gsap.fromTo(
      chars,
      { ...from },
      {
        ...to,
        duration,
        ease,
        stagger: delay,
      }
    );
  }, []);

  return (
    <h1
      ref={containerRef}
      className={`text-white drop-shadow-[0_0_6px_rgba(255,255,255,0.2)] ${className}`}
    >
      {text.split("").map((char, index) => (
        <span
          key={index}
          className="char inline-block"
          style={{
            translate: "none",
            rotate: "none",
            scale: "none",
            transform: "translate(0px, 0px)",
            opacity: 0, // Start with opacity 0, animation will make it visible
          }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </h1>
  );
};

export default SplitText;